import { zonedTimeToUtc } from 'date-fns-tz';

/**
 * Get age of date.
 * @param {string} dateString - The date string in ISO 8601 format (example: '2023-07-31T04:23:38.807Z').
 * @returns {string} The age of the date .
 */
export const AgeOfDate = (dateString: string): string =>
    `${Math.floor(
        (new Date().getTime() - new Date(dateString).getTime()) /
            (1000 * 60 * 60 * 24)
    )}`;

export const createDateAsUTC = (date: Date): Date =>
    new Date(
        Date.UTC(
            date.getFullYear(),
            date.getMonth(),
            date.getDate(),
            date.getHours(),
            date.getMinutes(),
            date.getSeconds()
        )
    );

export const isValidDate = (date: Date): boolean =>
    date &&
    // eslint-disable-next-line no-self-compare
    date.getTime() === date.getTime();

export const getTimeZoneDate = (date: Date, timezone = 'Australia/NSW'): Date =>
    Intl.DateTimeFormat().resolvedOptions().timeZone === timezone
        ? date
        : zonedTimeToUtc(date, timezone);
export const validateInputDate = (testdate: string): boolean => {
    const date_regex = /^\d{2}\/\d{2}\/\d{4}$/;
    return date_regex.test(testdate);
};
